import cx from "classnames";
import { ElementType, ReactNode } from "react";

import CardUiBodyMedia from "./CardUiBodyMedia";
import CardUiButtonLeft from "./CardUiButtonLeft";
import CardUiButtonRight from "./CardUiButtonRight";
import CardUiInfoBlock from "./CardUiInfoBlock";
import CardUiTitle from "./CardUiTitle";
import styles from "./styles.module.css";

export type CardUiProps = {
  as?: ElementType;
  className?: string;
  children: ReactNode;
};

const CardUi = ({
  children,
  className = "",
  as: Element = "div",
}: CardUiProps) => {
  return (
    <Element
      className={cx(styles.container, className, styles.subcategoryCard)}
    >
      {children}
    </Element>
  );
};

CardUi.BodyMedia = CardUiBodyMedia;
CardUi.Title = CardUiTitle;
CardUi.InfoBlock = CardUiInfoBlock;
CardUi.ButtonLeft = CardUiButtonLeft;
CardUi.ButtonRight = CardUiButtonRight;

export default CardUi;
